// store/useFeedbackPopupStore.js

import { create } from "zustand";

const useFeedbackPopupStore = create((set) => ({
  showPopup: false,

  setFeedbackPopup: (show) => set({ showPopup: show }),
  clearFeedbackPopup: () => set({ showPopup: false }),
}));

export default useFeedbackPopupStore;